<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 16 16" preserveAspectRatio="xMidYMid meet" fill="none" role="presentation" ref="host">
    <g>
      <path fill="#BC98F9" d="m4.855 2.504-.005.002a1.679 1.679 0 0 0-1.003 2.152l2.59 7.122a1.679 1.679 0 0 0 2.152 1.003l.005-.002a1.679 1.679 0 0 0 1.003-2.151l-2.59-7.122a1.679 1.679 0 0 0-2.152-1.004Zm5.25 2.67-.01.004a1.31 1.31 0 0 0-.783 1.678l1.88 5.169a1.31 1.31 0 0 0 1.679.783l.01-.004a1.31 1.31 0 0 0 .783-1.678l-1.88-5.169a1.31 1.31 0 0 0-1.679-.783Z" />
      <path fill="#6F77EC" d="m11.578 11.198 1.713-3.673a1.126 1.126 0 0 1 1.491-.543 1.12 1.12 0 0 1 .527 1.491l-1.702 3.67a1.122 1.122 0 0 1-1.492.544 1.12 1.12 0 0 1-.537-1.49ZM9.06 5.888l-2.23 4.784a1.491 1.491 0 0 0 .722 1.982l.004.002a1.492 1.492 0 0 0 1.983-.721l2.23-4.784a1.491 1.491 0 0 0-.721-1.982l-.005-.002a1.491 1.491 0 0 0-1.982.721ZM4.648 9.97l2.324-5.007a1.879 1.879 0 0 0-.894-2.503 1.882 1.882 0 0 0-2.45.951L1.306 8.418a.564.564 0 0 0 .264.746l2.371 1.101a.548.548 0 0 0 .707-.295Zm-2.996 2.846 2.01-1.054a.38.38 0 0 0 0-.683L1.127 9.912a.38.38 0 0 0-.506.171.372.372 0 0 0-.026.264l.527 2.224a.387.387 0 0 0 .474.263l.056-.018Z" />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
